import React from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import useTranslation from "locales";

import { numberWithoutSpaces } from "functions/numberWithoutSpaces";
import "./footer.scss";

const Footer = ({ lang, data }) => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation(lang);

  const info = data.info.nodes[0].acfInformation.acfInformation;
  return (
    <footer>
      <div className="footer__main">
        <div className="container">
          <div className="row flex-md-row flex-column-reverse g-0">
            <div className="col-xl-3 col-md-4 footer__col">
              <h6 className="footer__col-title">{t("Kontakt")}</h6>
              <p
                className="footer__col-content"
                dangerouslySetInnerHTML={{
                  __html: info.address,
                }}
              />
              <p className="footer__col-content">
                {info.numberPl ? "PL: " : ""}
                <a
                  href={`tel:${numberWithoutSpaces(info.numberPl)}`}
                  className="footer__col-link"
                >
                  {info.numberPl}
                </a>
              </p>
              {/* <div className="footer__phone-container">
								{t(
									"Automatyczna infolinia telefoniczna czynna przez całą dobę / 7 dni w tygodniu:"
								)}
								<a href="tel:+48459595777">+48 459 595 777</a>
								<span className="footer__small">
									{t(
										"*Konsultanci telefoniczni są dostępni codziennie w godzinach 12:30-20:30. Opłata za połączenie jest zgodna z cennikiem Państwa operatora."
									)}
								</span>
							</div> */}
            </div>
            <div className="col-xl-2 col-md-3 footer__col">
              <h6 className="footer__col-title">Menu</h6>
              <ul className="footer__col-list">
                <li className="footer__col-list-item">
                  <Link className="footer__col-link" to={t("/o-firmie/")}>
                    {t("O firmie")}
                  </Link>
                </li>
                <li className="footer__col-list-item">
                  <Link
                    className="footer__col-link"
                    to={t("/nasze-realizacje/")}
                  >
                    {t("Nasze realizacje")}
                  </Link>
                </li>
                <li className="footer__col-list-item">
                  <Link className="footer__col-link" to={t("/dla-mediow/")}>
                    {t("Dla mediów")}
                  </Link>
                </li>
                <li className="footer__col-list-item">
                  <Link
                    className="footer__col-link"
                    to={t("/dla-sponsorow/")}
                    dangerouslySetInnerHTML={{
                      __html: t("Dla sponsorów"),
                    }}
                  />
                </li>
                <li className="footer__col-list-item">
                  <Link className="footer__col-link" to={t("/aktualnosci/")}>
                    {t("Aktualności")}
                  </Link>
                </li>
                <li className="footer__col-list-item">
                  <Link className="footer__col-link" to={t("/kariera/")}>
                    {t("Kariera")}
                  </Link>
                </li>
                <li className="footer__col-list-item">
                  <Link className="footer__col-link" to={t("/regulaminy/")}>
                    {t("Regulaminy")}
                  </Link>
                </li>
                <li className="footer__col-list-item">
                  <Link className="footer__col-link" to={t("/kontakt/")}>
                    {t("Kontakt")}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-xl-3 col-md-4 footer__col">
              <h6 className="footer__col-title">{t("Nasze Ogrody Świateł")}</h6>
              <ul className="footer__col-list">
                <li className="footer__col-list-item">
                  <a
                    href={t("https://chorzow.ogrodswiatel.pl/")}
                    className="footer__col-link"
                  >
                    {t("Ogród Świateł")} - {t("CHORZÓW")}
                  </a>
                </li>
                <li className="footer__col-list-item">
                  <a
                    href={t("https://warszawa.ogrodswiatel.pl/")}
                    className="footer__col-link"
                  >
                    {t("Ogród Świateł")} - {t("WARSZAWA")}
                  </a>
                </li>
                <li className="footer__col-list-item">
                  <a
                    href={t("https://krakow.ogrodswiatel.pl/")}
                    className="footer__col-link"
                  >
                    {t("Ogród Świateł")} - {t("KRAKÓW")}
                  </a>
                </li>
                <li className="footer__col-list-item">
                  <a
                    href={t("https://gdynia.ogrodswiatel.pl/")}
                    className="footer__col-link"
                  >
                    {t("Ogród Świateł")} - {t("GDYNIA")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer__fox-container">
            <img
              src={require("assets/images/logo-vertical-white.svg").default}
              alt=""
              className="footer__logo img-fluid"
            />
            <img
              src={require("assets/images/fox.png").default}
              alt=""
              className="footer__fox img-fluid"
            />
          </div>
        </div>
      </div>
      <div className="footer__copyright">
        <div className="container">
          <div>
            &copy; {currentYear} Ogród Świateł - All Rights Are Reserved
          </div>
          <div>
            <a
              href={t("https://adream.pl/")}
              target="_blank"
              className="footer__copyright-link"
              rel="noreferrer nofollow"
            >
              {t("Projekt i realizacja")}{" "}
              <img
                src={require("../../assets/images/adream.svg").default}
                alt=""
                className="footer__copyright-adream"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default function FooterStatic(props) {
  return (
    <StaticQuery
      query={graphql`
        {
          info: allWp {
            nodes {
              acfInformation {
                acfInformation {
                  emailContact
                  numberPl
                  numberEn
                  address
                }
              }
            }
          }
        }
      `}
      render={(data) => <Footer data={data} {...props} />}
    />
  );
}
